import React, { useEffect } from 'react';
import './rops2026.css';
import { rops2026 } from '../../json/rops2026';

const Rops2026 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Reglas de Operación 2026</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
             
              <div style={{ textAlign: 'left' }}>
                
  
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROPs_Programa_Subsidio_al_Servicio_de_Verificacion_Vehicular_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa de Subsidio al Servicio de Verificación Vehicular para el Ejercicio Fiscal 2026</a></strong></h5>
                
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/Modificacion_Disposiciones_Acuerdo_Reglas_Operacion_Programa_Subsidio_Servicio_Verificacion_Vehicular_EF_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Modificación abril de 2026</a><br />
                  </li>
                  </ul>

                 <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Institucional_de_Atencion_a_las_Juventudes_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Institucional de Atención a las Juventudes para el Ejercicio Fiscal 2026</a></strong></h5>

                 <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Bienestar_de_Madres_Trabajadoras_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Bienestar de Madres Trabajadoras para el Ejercicio Fiscal 2026</a></strong></h5>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Bienestar_de_Personas_Cuidadoras_de_Personas_con_Discapacidad_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Bienestar de Personas Cuidadoras de Personas con Discapacidad para el Ejercicio Fiscal 2026</a></strong></h5>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Bienestar_para_Personas_Artesanas_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Bienestar para Personas Artesanas para el Ejercicio Fiscal 2026</a></strong></h5>

                 <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Desarrollo_Inclusivo_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Desarrollo Inclusivo para el Ejercicio Fiscal 2026</a></strong></h5>

                 <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_de_Atencion_a_Personas_Migrantes_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Atención a Personas Migrantes para el Ejercicio Fiscal 2026</a></strong></h5>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Estatal_Apoyo_para_el_Bienestar_y_el_Desarrollo_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Estatal Apoyo para el Bienestar y Desarrollo para el Ejercicio Fiscal 2026</a></strong></h5>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Fomento_Artesanal_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Fomento Artesanal para el Ejercicio Fiscal 2026</a></strong></h5>

                 <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/Lineamientos_Programa_Atencion_Adultos_Mayores_EF_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Líneamientos del Programa Atención a Adultos Mayores para el Ejercicio Fiscal 2026</a></strong></h5>

                 <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/Lineamientos_Programa_Atencion_al_Pueblo_EF_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Líneamientos del Programa Atención al Pueblo para el Ejercicio Fiscal 2026</a></strong></h5>


              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Rops2026;